import pt from 'react-intl/locale-data/pt';
import en from 'react-intl/locale-data/en';
import es from 'react-intl/locale-data/es';
import { addLocaleData } from 'react-intl';
import messages from './messages';

// Prepare locales
addLocaleData([...pt, ...en, ...es]);

function getLocalizedObject(object, locale, depth = 0) {
  return Object.keys(object).reduce((localized, key) => {
    localized[key] = depth
      ? getLocalizedObject(object[key], locale, depth - 1)
      : object[key][locale];
    return localized;
  }, {});
}

export default function(language) {
  return {
    locale: language,
    messages: getLocalizedObject(messages, language),
  };
}



// WEBPACK FOOTER //
// ./src/intl/index.js